import React from "react";
import {
  Dialog,
  DialogContent,
  DialogActions,
  Button,
  useMediaQuery,
  useTheme,
} from "@mui/material";

export const CustomConfirmationDialog = ({
  open,
  carouselItems = [],
  currentIndex = 0,
  onCancel,
  onDoNotShowAgain,
  onLearnMore,
  onNext,
  onPrevious,
}) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm")); // Detecta telas pequenas
  const link = carouselItems[currentIndex]?.link; // Obtém o link do item atual, pode ser undefined ou null

  const extractVideoId = (url) => {
    if (!url || typeof url !== "string") {
      console.error("Erro: URL inválida ou não fornecida.");
      return null; // Retorna null se a URL for inválida
    }

    const regex = /[?&]v=([^&]+)/; // Regex para extrair o ID do vídeo
    const match = url.match(regex); // Tenta encontrar o ID do vídeo
    return match ? match[1] : null; // Retorna o ID ou null se não encontrar
  };

  const videoUrl = carouselItems[currentIndex]?.video;
  const videoId = extractVideoId(videoUrl);

  return (
    <Dialog
      open={open}
      onClose={onCancel}
      maxWidth="lg" // Tamanho máximo
      PaperProps={{
        style: {
          width: isMobile ? "360px" : "1024px", // Fixar largura em `sm` e `lg`
          height: isMobile ? "640px" : "720px", // Fixar altura em `sm` e `lg`
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          overflow: "hidden",
        },
      }}
    >
      {/* Botão de fechar */}
      <button
        onClick={onCancel}
        style={{
          position: "absolute",
          top: "10px",
          right: "10px",
          width: "40px",
          height: "40px",
          backgroundColor: "rgba(255, 255, 255, 0.8)",
          border: "none",
          borderRadius: "50%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          cursor: "pointer",
          fontSize: "20px",
          color: "#0f2269",
          zIndex: 10,
        }}
      >
        &#x2715;
      </button>

      {/* Conteúdo do Modal */}
      <DialogContent
        style={{
          width: "100%",
          height: "100%",
          padding: 0,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        {carouselItems[currentIndex]?.video ? (
          <iframe
            title="video"
            src={`https://www.youtube.com/embed/${videoId}?autoplay=1`}
            allow="autoplay"
            allowFullScreen
            style={{
              width: "100%",
              height: "100%",
              objectFit: "fill",
            }}
          ></iframe>
        ) : (
          <img
            src={carouselItems[currentIndex]?.image}
            alt={carouselItems[currentIndex]?.name}
            style={{
              width: "100%",
              height: "100%", // Preencher o espaço disponível
              objectFit: "fill", // Ajuste sem distorção
            }}
          />
        )}

        {/* Setas de Navegação */}
        {!isMobile && (
          <>
            <button
              onClick={onPrevious}
              style={{
                position: "absolute",
                top: "50%",
                left: "10px",
                transform: "translateY(-50%)",
                background: "rgba(0, 0, 0, 0.5)",
                color: "white",
                border: "none",
                borderRadius: "50%",
                padding: "12px",
                cursor: "pointer",
              }}
            >
              &#9664;
            </button>
            <button
              onClick={onNext}
              style={{
                position: "absolute",
                top: "50%",
                right: "10px",
                transform: "translateY(-50%)",
                background: "rgba(0, 0, 0, 0.5)",
                color: "white",
                border: "none",
                borderRadius: "50%",
                padding: "12px",
                cursor: "pointer",
              }}
            >
              &#9654;
            </button>
          </>
        )}
      </DialogContent>

      {/* Ações no final */}
      <DialogActions
        style={{ justifyContent: "space-between", padding: "10px" }}
      >
        <Button
          variant="text"
          color="primary"
          onClick={onDoNotShowAgain}
          style={{ textTransform: "none", color: "#0f2269" }}
        >
          Não exibir novamente
        </Button>

        {link && link.trim() !== "" && (
          <Button
            variant="text"
            color="primary"
            onClick={() => onLearnMore(link)}
            style={{ textTransform: "none", color: "#0f2269" }}
          >
            Saiba Mais
          </Button>
        )}
      </DialogActions>
    </Dialog>
  );
};
